import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    constructor(private _snackbar: MatSnackBar) {}

    successSnackbar(message: string) {
        this._snackbar.open(message, 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 5 * 1000,
            panelClass: ['success-snackbar'],
        });
    }

    warnSnackbar(message: string) {
        this._snackbar.open(message, 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 5 * 1000,
            panelClass: ['warn-snackbar'],
        });
    }

    dangerSnackbar(message: string) {
        this._snackbar.open(message, 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 5 * 1000,
            panelClass: ['danger-snackbar'],
        });
    }

    errorSnackbar(message: string) : MatSnackBarRef<any> {
       return this._snackbar.open(message, 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 10 * 1000,
            panelClass: ['danger-snackbar-dark'],
        });
    }

    infoSnackbar(message: string) {
        this._snackbar.open(message, 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 5 * 1000,
            panelClass: ['info-snackbar'],
        });
    }
    
    questionnaireUpdated() {
        this._snackbar.open('Questionnaire updated!', 'Close', {
            horizontalPosition: 'start',
            verticalPosition: 'bottom',
            duration: 5 * 1000,
            panelClass: ['success-snackbar'],
        });
    }
}
